import { CommentOutlined, QuestionOutlined } from "@ant-design/icons"
import { Dropdown } from "components/Dropdown/Dropdown"
import { FloatButton } from "components/FloatButton/FloatButton"
import { useRightSidebar } from "hooks/useRightSidebar"
import { useFlag } from "modules/flags/flags"
import { useHelpMenuOption } from "modules/help/useHelpMenuOption"
import { useViewLegal } from "modules/legal/useViewLegal"
import { useSupportRequests } from "modules/support/useSupportRequests"
import { useZendesk } from "modules/zendesk/useZendesk"
import { useMemo } from "react"

export function PatientSpeedDial() {
	const { setSidebarState } = useRightSidebar()
	const flags = useFlag("chatMessageInApp")
	const supportRequests = useSupportRequests()
	const viewLegal = useViewLegal()
	const zendesk = useZendesk()
	const helpDocItem = useHelpMenuOption()
	const omnichannelItem = useMemo(() => {
		if (!flags.chatMessageInApp.enabled) {
			return null
		}
		return {
			key: "omnichannel",
			label: "Contact medical team",
			icon: <CommentOutlined aria-hidden />,
			onClick: () => setSidebarState({ key: "omnichannel" }),
		}
	}, [flags.chatMessageInApp.enabled, setSidebarState])

	return (
		<>
			<Dropdown
				trigger={["click"]}
				placement="topLeft"
				menu={{
					"aria-label": "Application and help options",
					items: [
						...viewLegal.items,
						...zendesk.items,
						omnichannelItem,
						...supportRequests.items,
						helpDocItem,
					],
				}}
			>
				<FloatButton
					type="primary"
					icon={<QuestionOutlined aria-hidden />}
					className="absolute bottom-6 z-0"
					aria-label="Application and help options"
				/>
			</Dropdown>

			{viewLegal.viewer}
		</>
	)
}
